import { render, staticRenderFns } from "./WithDraw.vue?vue&type=template&id=5b52b1ec&scoped=true"
import script from "./WithDraw.vue?vue&type=script&lang=js"
export * from "./WithDraw.vue?vue&type=script&lang=js"
import style0 from "./WithDraw.vue?vue&type=style&index=0&id=5b52b1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52b1ec",
  null
  
)

export default component.exports